import React, { useEffect, useRef, useState } from 'react';
import Table from 'react-bootstrap/Table';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Pagination from '@mui/material/Pagination';
import { NavLink } from 'react-router-dom';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import { postRequest } from '../../../lib/api';
import {Link} from 'react-router-dom'
import toast from 'react-hot-toast';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import BreadcrumbsWrapper from '../../../components/breadcrumbs'
import Swal from 'sweetalert2';


const CustomLeadFees = () => {
  const [feeData, setFeeData] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalDocs, setTotalDocs] = useState(0);
  const [loading, setLoading] = useState(false);

  const debounceRef = useRef();

  const fetchFees = async (searchTerm = '', pageVal = page) => {
    setLoading(true);
    try {
      const res = await postRequest('private/customLeadFeesList', {
        search: searchTerm,
        isDeleted: 0,
        page: pageVal,
        limit: 5,
      });

      if (res?.status === 200 && res?.data?.docs) {
        setFeeData(res.data.docs);
        setTotalPages(res.data.totalPages || 1);
        setTotalDocs(res.data.totalDocs || 0);
      } else {
        setFeeData([]);
        setTotalPages(1);
        setTotalDocs(0);
      }
    } catch (err) {
      setFeeData([]);
      setTotalPages(1);
      setTotalDocs(0);
    } finally {
      setLoading(false);
    }
  };

    const handleToggleStatus = async (id) => {
    try {
      const res = await postRequest(`private/changeStatus/${id}`, {});
       //console.log(res , 'response213423423')
      if (res?.status === 200) {
        fetchFees(search, page);
       // toast.success(res?.message)
      } else {
        //toast.error('Status change failed');
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchFees();
  }, [page]);

  useEffect(() => {
    setPage(1);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      fetchFees(search, 1);
    }, 400);
  }, [search]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleDelete = async (id) => {
  const confirm = await Swal.fire({
    title: 'Are you sure?',
    text: 'You will not be able to recover this custom lead fee!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#bb0000',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!',
  });

  if (confirm.isConfirmed) {
    try {
      const res = await postRequest(`private/deleteCustomLeadFee/${id}`, {});
      if (res?.status === 200) {
       // toast.success('Custom lead fee deleted!');
         // Adjust page if last item deleted
        const isLastItemOnPage = feeData.length === 1 && page > 1;
        fetchFees(search, isLastItemOnPage ? page - 1 : page);
        //fetchFees(search, page); // Refresh list
      } else {
        //toast.error(res?.message || 'Failed to delete');
      }
    } catch (err) {
      toast.error('Server error while deleting');
    }
  }
};


  return (
    <>
       <BreadcrumbsWrapper
                                                items={[
                                                  { label: 'Dashboard', path: '/dashboard' },
                                                  { label: 'CustomLeadFees', path: '' },
                                                
                                                 
                                                ]}
                                              />
                                        <br></br>
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <div className='page-header pb-3' style={{ display: 'flex', justifyContent: 'space-between' }}>
        <h1 className='mt-0 mb-0'>Custom Lead Fees</h1>
        <Stack spacing={2} direction="row">
          <Button variant="outlined" className='red-outline-btn text-capitalize'>
            <NavLink to="/custom/create/lead-fees" className="red-link-text">
              <PersonAddOutlinedIcon /> &nbsp; Add Custom Lead Fees
            </NavLink>
          </Button>
        </Stack>
      </div>

      <div style={{ margin: '20px 0' }}>
        <TextField
          label="Search by title"
          variant="outlined"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
         // size="small"
          fullWidth
        />
      </div>

   <Table striped responsive bordered>
  <thead>
    <tr>
      <th>Title</th>
      <th>Net</th>
      <th>Tax Exempt?</th>
      <th>Gross</th>
      <th>Active?</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    {loading ? (
      <tr>
        <td colSpan={6} style={{ textAlign: 'center' }}>
          <CircularProgress size={28} />
        </td>
      </tr>
    ) : feeData.length === 0 || feeData.every(section => section.data.length === 0) ? (
      <tr>
        <td colSpan={6} style={{ textAlign: 'center' }}>
          No custom lead fees found.
        </td>
      </tr>
    ) : (
      feeData.map((section, index) => (
        <React.Fragment key={index}>
          {/* Section Header Row */}
          <tr>
            <td colSpan={6} className="bg-grey" style={{ fontWeight: 'bold' }}>
              {section.title}
            </td>
          </tr>

          {/* Section Data Rows */}
          {section.data.map((fee, idx) => (
            <tr key={fee._id || idx}>
              <td>{fee.title}</td>
              <td>£{fee.net?.toFixed(2)}</td>
              <td>{fee.tax_exempt ? <CheckIcon style={{ width: "1.1rem" }} /> : <CloseIcon style={{ width: "1.1rem" }} />}</td>
              <td>£{(fee.tax_exempt ? fee.net : (fee.net * 1.2))?.toFixed(2)}</td>
              <td>{fee.isActive ? <CheckIcon style={{ width: "1.1rem" }} /> : <CloseIcon style={{ width: "1.1rem" }} />}</td>
              <td>
                <span
                  className="red-link-text"
                  style={{ marginRight: 10, cursor: 'pointer' }}
                  onClick={() => handleToggleStatus(fee._id)}
                >
                  (toggle)
                </span>
                <Link className="red-link-text" to={`/custom/edit/lead-fees/${fee._id}`}>
                     <EditOutlinedIcon />
                </Link>
                <span
  className="red-link-text"
  title="Delete"
  onClick={() => handleDelete(fee._id)}
  style={{ cursor: 'pointer' }}
>
  <DeleteOutlineOutlinedIcon />
</span>

              </td>
               
            </tr>
          ))}
        </React.Fragment>
      ))
    )}
  </tbody>
</Table>


      {feeData.length > 0 && (
        <>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 8, marginBottom: 8 }}>
            <span className="text-muted small">
              Showing {((page - 1) * 5) + 1}-{Math.min(page * 5, totalDocs)} of {totalDocs} custom lead fees
            </span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 8 }}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={handlePageChange}
              color="primary"
              shape="rounded"
              size="medium"
              sx={{
                  '& .Mui-selected': {
                    background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%) !important',
                    color: '#fff !important',
                  },
                  '& .MuiPaginationItem-root': {
                    color: 'var(--bs-red-color)',
                    borderColor: 'var(--bs-red-color)',
                  },
                }}
            />
          </div>
        </>
      )}
    </div>
    </>
  );
};

const thStyle = {
  border: '1px solid #ccc',
  padding: '8px',
  backgroundColor: '#f5f5f5',
  textAlign: 'left'
};

const tdStyle = {
  border: '1px solid #ccc',
  padding: '8px',
  textAlign: 'left'
};

export default CustomLeadFees;